import SelectInput from "../shared/Inputs/SelectInput";
import { TextInput } from "../shared/Inputs/TextInput";

interface AccountEditFinanceSectionProps {
  register: any;
  setValue: any;
  watch: any;
  accountStatusOpts: string[];
  currentStatus?: number;
}

export function AccountEditFinanceSection({
  register,
  setValue,
  watch,
  accountStatusOpts,
  currentStatus,
}: AccountEditFinanceSectionProps) {
  const status = currentStatus ?? 2;

  const statusClassName = {
    0: "bg-amber-100 text-amber-600",
    1: "bg-red-100 text-red-600",
    2: "bg-green-100 text-green-600",
  }[status];

  const statusLabel = {
    0: "Archived",
    1: "Disabled",
    2: "Enabled",
  }[status];

  return (
    <div className="space-y-3 rounded-md border border-gray-200 bg-white p-4">
      <div className="flex items-center justify-between">
        <div className="pb-1 border-b border-gray-100">
          <p className="text-sm font-semibold text-gray-800">Finance</p>
          <p className="text-xs text-gray-500">Status, VAT and banking</p>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-bold ${statusClassName}`}>
          {statusLabel}
        </span>
      </div>
      <SelectInput
        label="Account Status"
        register={register}
        registerName="status"
        setValue={setValue}
        watch={watch}
        options={accountStatusOpts.map((opt, i) => ({ id: i, name: opt }))}
        rounded
      />
      <TextInput
        label="VAT Number"
        register={register}
        registerName="vatNumber"
        rounded
      />
      <div>
        <label className="text-sm font-medium text-gray-500">Credit Limit</label>
        <div className="relative mt-1">
          <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
            GBP
          </span>
          <input
            {...register("creditLimit")}
            className="w-full rounded-md border-1 border-gray-300 py-2 pl-12 pr-3 text-right text-sm text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>
      </div>
      <div className="pt-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Bank Details
        </p>
      </div>
      <TextInput
        label="Bank Account Name"
        register={register}
        registerName="bankAccountName"
        rounded
      />
      <TextInput
        label="Sort Code"
        register={register}
        registerName="bankSortCode"
        rounded
      />
      <TextInput
        label="Bank Account Number"
        register={register}
        registerName="bankAccountNumber"
        rounded
      />
      <div className="pt-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Oracle Billing
        </p>
        <p className="text-xs text-gray-500">
          Used by the Oracle invoice export. Oracle identifies the customer by its own codes, so
          the export can't run for this account until the number, site and contact are set.
        </p>
      </div>
      <TextInput
        label="Oracle Customer Number"
        register={register}
        registerName="oracleCustomerNumber"
        rounded
      />
      <TextInput
        label="Oracle Customer Site"
        register={register}
        registerName="oracleCustomerSite"
        rounded
      />
      <TextInput
        label="Oracle Client Contact"
        register={register}
        registerName="oracleContactName"
        rounded
      />
      <TextInput
        label="Oracle Contact Email"
        register={register}
        registerName="oracleContactEmail"
        rounded
      />
      <TextInput
        label="Oracle Customer PO Reference"
        register={register}
        registerName="oracleCustomerPoRef"
        rounded
      />
      <TextInput
        label="Oracle Line Item"
        register={register}
        registerName="oracleLineItem"
        rounded
      />
      <p className="text-xs text-gray-500">
        Only needed if this customer is billed on a different REC item to the rest of the site.
        Leave blank to use the site default.
      </p>
    </div>
  );
}

